import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=6cb6647e&scoped=true&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"
import style0 from "./Payment.vue?vue&type=style&index=0&id=6cb6647e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb6647e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb6647e')) {
      api.createRecord('6cb6647e', component.options)
    } else {
      api.reload('6cb6647e', component.options)
    }
    module.hot.accept("./Payment.vue?vue&type=template&id=6cb6647e&scoped=true&", function () {
      api.rerender('6cb6647e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/billing/Payment.vue"
export default component.exports